import Button from 'components/common/Button';
import Link from 'next/link';
import Text from '@/components/common/Text';
import Heading from '@/components/common/Heading';
import { LandingCardBase } from '../landing/LandingCardBase';

export const BecomeAnInfluencer = () => {
  return (
    <>
      <div className='w-full'>
        <LandingCardBase className='p-9'>
          <div className='mr-auto flex w-full flex-col items-start justify-start gap-y-16 md:w-10/12'>
            <div className='flex flex-grow flex-col items-start justify-start gap-y-5'>
              <div className='relative flex h-10 w-10 flex-row items-center justify-center'>
                <img
                  alt='Networking Icon'
                  width='38'
                  height='38'
                  src='https://res.cloudinary.com/dbkbadq4w/image/upload/q_auto/f_auto/reseller_icon-blk.png'
                />
              </div>
              <Heading size={3}>Become an influencer</Heading>
              <Text size='paragraph'>
                Expand opportunities. Join our influencer professional network.
              </Text>
            </div>
            <Link href={{ pathname: '/support/become-influencer' }}>
              <Button>Learn more</Button>
            </Link>
          </div>
        </LandingCardBase>
      </div>
    </>
  );
};
